<template>
    <div :style="style" ref="lavContainer" @onComplete="onComplete"></div>
</template>

<script>
  import bodymovin from 'bodymovin';

  export default {
    props: {
      options: {
        type: Object,
        required: true
      },
      height: Number,
      width: Number
    },

    data () {
      return {
        style: {
          width: this.width ? `${this.width}px` : '100%',
          height: this.height ? `${this.height}px` : '100%',
          overflow: 'hidden',
          margin: '0 auto'
        }
      }
    },

    mounted () {
      this.anim = bodymovin.loadAnimation({
          container: this.$refs.lavContainer,
          renderer: 'svg',
          loop: this.options.loop !== false,
          autoplay: this.options.autoplay !== false,
          animationData: this.options.animationData,
          rendererSettings: this.options.rendererSettings
        }
      );
      this.$emit('animCreated', this.anim)

      this.anim.addEventListener('complete', (e) => this.$emit('complete', e))
      this.anim.addEventListener('loopComplete', (e) => this.$emit('loopComplete', e))
    //   this.anim.addEventListener('enterFrame', (e) => this.$emit('enterFrame', e))
      this.anim.addEventListener('segmentStart', (e) => this.$emit('segmentStart', e))
      this.anim.addEventListener('config_ready', (e) => this.$emit('configReady', e))
      this.anim.addEventListener('data_ready', (e) => this.$emit('dataReady', e))
      this.anim.addEventListener('loaded_images', (e) => this.$emit('loadedImages', e))
      this.anim.addEventListener('DOMLoaded', (e) => this.$emit('DOMLoaded', e))
      this.anim.addEventListener('destroy', (e) => this.$emit('destroy', e))
    },
    methods: {
      onComplete (e) {
        // console.log('onComplete@@@@', e)
      }
    }
    // beforeDestroy() {
    //   this.$el.removeEventListener('dragster:enter', (e) => this.$emit('enter', e))
    //   this.$el.removeEventListener('dragster:leave', (e) => this.$emit('leave', e))
    //   this.dragster.removeListeners()
    // }
  }
</script>



// WEBPACK FOOTER //
// src/components/AnimLottie.vue